import React from 'react';
import {useTranslation} from 'react-i18next';
import Page from '../../components/acommon/Page';
import CheckinNavigation from '../../components/acommon/CheckinNavigation';
import TouristTaxesSetup from '../../components/Taxes/TouristTaxesSetup';
import {DimensionsWrapper} from 'styled/common';

function TouristTaxesScreen() {
  const {t} = useTranslation();

  return (
    <Page showFooterOnlyMobile paddingBottomMobileFooter>
      <CheckinNavigation title={t('tourist_taxes')} />
      <DimensionsWrapper>
        <TouristTaxesSetup />
      </DimensionsWrapper>
    </Page>
  );
}

export {TouristTaxesScreen};
